import {Resolution} from '@/shared/model/resolution/resolution.model';

export const enum ReceivedAnswerStatus {
  NEW = 'NEW',
  SEEN = 'SEEN',
  ACCEPT = 'ACCEPT',
  CANCEL = 'CANCEL',
}

export const enum NgoDecisionStatus {
  ALLOWED,
  REJECTED
}

export interface IReceivedAnswer {
  id?: number;
  status?: ReceivedAnswerStatus;
  resultMessage?: string;
  acceptMessage?: string;
  cancelMessage?: string;
  taskReceivedId?: number;
  answerTypeId?: number;
  appealStatusId?: number;
  forwardedOrganizationId?: number;
  forwardedBranchId?: number;
  appealSolutionWayIdList?: number[];
  receivedAnswerFileList?: any[];
  resolution?: Resolution;
  isTaskForwardToBranches?: number;
  forwardedResolutionId?: number;
  taskForwardResolution?: Resolution;
  outsideHybridMail?: number;
  outsideEXat?: number;
  sendByEmail?: number;
  emailAddressForSend?: string;
  outsideSendingAddress?: string;
  outsideSendingAddressEXat?: string;
  hybridMailRegion?: number;
  hybridMailDistrict?: number;
  ngoDecisionStatus?: NgoDecisionStatus;
}

export class ReceivedAnswer implements IReceivedAnswer {
  constructor(
    public id?: number,
    public status?: ReceivedAnswerStatus,
    public resultMessage?: string,
    public acceptMessage?: string,
    public cancelMessage?: string,
    public taskReceivedId?: number,
    public answerTypeId?: number,
    public appealStatusId?: number,
    public forwardedOrganizationId?: number,
    public forwardedBranchId?: number,
    public appealSolutionWayIdList?: number[],
    public receivedAnswerFileList?: any[],
    public resolution?: Resolution,
    public isTaskForwardToBranches?: number,
    public forwardedResolutionId?: number,
    public taskForwardResolution?: Resolution,
    public outsideHybridMail?: number,
    public outsideEXat?: number,
    public sendByEmail?: number,
    public emailAddressForSend?: string,
    public outsideSendingAddress?: string,
    public outsideSendingAddressEXat?: string,
    public hybridMailRegion?: number,
    public hybridMailDistrict?: number,
    public ngoDecisionStatus?: NgoDecisionStatus
  ) {
    this.receivedAnswerFileList = [];
    this.appealSolutionWayIdList = [];
    this.resolution = new Resolution();
    this.taskForwardResolution = new Resolution();
    this.outsideHybridMail = 0;
    this.outsideEXat = 0;
    this.sendByEmail = 0;
    this.resultMessage = '';
    this.isTaskForwardToBranches = 0;
  }
}
